import UIUXDesignLp2 from './UIUXDesignLp2'

export default UIUXDesignLp2
